// extracted by mini-css-extract-plugin
export default {"dashboardCandidate":"G0WIdNPjjNpm0R4pROBA","leftHeader":"KSluNExa1vdyFjPP5qCA","description":"a2qrW9smIIwxn7iVbPmf","btnContainer":"kqhVTKJalIi3SfIrJlmQ"};